import { anyApi } from 'convex/server';

// We intentionally use anyApi because generated Convex types are not part of this repo.
export const api = anyApi as any;
